const routes = [
  {
    path: '/personAuthorization', // 人员通行授权
    name: 'personAuthorization',
    component: () => import('./pages/Home'),
    redirect: '/personAuthorization/index',
    meta: {
      requireAuth: false
    },
    children: [
      {
        path: 'index',
        name: 'authorizationIndex',
        component: () => import('./pages/index'),
        meta: {
          requireAuth: false,
          routerAlive: true
        }
      },
    ]
  }
]

export default routes